jQuery( $ => {
    const $body = $( 'body' );

    $('img[usemap]').rwdImageMaps();

    $body.on( 'click', '.toggle-mobile-menu', event => {
        event.preventDefault();

        $body.toggleClass( 'mobile-menu-active' );
    } );

    $( 'blockquote' ).fitText( 1, {
        minFontSize: 18,
        maxFontSize: 24
    } );

    $( '.blog-category-picker' ).change( function () {
        if ( this.value !== '' ) {
            window.location.href = `/category/${this.value}`;
        }
    } );
} );
